import React from 'react';
import type {CheckoutBrandModel} from '../../../domain/models/common/CheckoutBrand.model';
import {hexToRgbString} from '../../../domain/utils/colors';

export function getBrandStyle(checkoutBrand?: CheckoutBrandModel): React.CSSProperties {
  const buttonColor = hexToRgbString(checkoutBrand?.buttonColor);
  const placeOrderButtonColor = hexToRgbString(checkoutBrand?.placeOrderButtonColor);
  const formBackgroundColor = hexToRgbString(checkoutBrand?.formBackgroundColor);
  const summaryBackgroundColor = hexToRgbString(checkoutBrand?.summaryBackgroundColor);
  const buttonTextColor = hexToRgbString(checkoutBrand?.buttonTextColor);
  const placeOrderButtonTextColor = hexToRgbString(checkoutBrand?.placeOrderButtonTextColor);
  const cornerRadius = checkoutBrand?.cornerRadius;
  const hasCornerRadius = typeof cornerRadius === 'number';

  return {
    ...(buttonColor && {'--checkoutButtonColor': buttonColor}),
    ...(placeOrderButtonColor && {'--checkoutPlaceOrderButtonColor': placeOrderButtonColor}),
    ...(formBackgroundColor && {'--checkoutFormBackgroundColor': formBackgroundColor}),
    ...(summaryBackgroundColor && {'--checkoutSummaryBackgroundColor': summaryBackgroundColor}),
    ...(buttonTextColor && {'--checkoutButtonTextColor': buttonTextColor}),
    ...(placeOrderButtonTextColor && {'--checkoutPlaceOrderButtonTextColor': placeOrderButtonTextColor}),
    ...(hasCornerRadius && {'--checkoutCornerRadius': `${cornerRadius}`}),
    ...(hasCornerRadius && {'--payments-co-border-radius': `${cornerRadius}`}),
  } as React.CSSProperties;
}
